import {
    RichTableColumns,
} from 'app/types/richtable.types'

import {
    ModificationFields,
} from './LocationChangeSummary.types'

const getColumns = (
    l: (l:string) => string,
):RichTableColumns<ModificationFields>[] => {
    return [
        {
            id: 'fieldName',
            headerProps: {
                children: l('CHANGE'),
            },
            mapCellProps: 'fieldName',
            componentName: 'ModifiedField',
            labelPrefixKeys: ['Location'],
        },
        {
            id: 'previousValue',
            headerProps: {
                children: l('PREVIOUS_VALUE'),
            },
            mapCellProps: 'previousValue',
            componentName: 'ModifiedValue',
        },
        {
            id: 'updatedValue',
            headerProps: {
                children: l('UPDATED_VALUE'),
            },
            mapCellProps: 'updatedValue',
            componentName: 'ModifiedValue',
        },
        {
            id: 'modifiedBy',
            headerProps: {
                children: l('MODIFIED_BY'),
            },
            mapCellProps: 'modifiedBy',
            componentName: 'ModifiedValue',
        },
        {
            id: 'modifiedOn',
            headerProps: {
                children: l('MODIFIED_ON'),
            },
            mapCellProps: 'modifiedOn',
            componentName: 'ModifiedValue',
        },
    ]
}

export default getColumns
